/* eslint-disable no-undef */
(function () {
  'use strict'

  angular.module('MktzapApp.Factories')
      .factory('ReportPayrollV2TransactionService', ReportPayrollV2TransactionService)

      ReportPayrollV2TransactionService.$inject = ['$resource']

  function ReportPayrollV2TransactionService($resource) {
      return $resource('', {}, {
          paged: {
              url: apiUrl + '/reports/payrollv2-transactions-search',
              method: 'GET',
              params: {},
              isArray: false
          }
      })
  }
  // eslint-disable-next-line semi
})();
